import { z, ZodType } from 'zod';
import { widgetBaseSchema, WidgetsName, WidgetType } from './common';

import { zObject } from '../../util/zod';
import { jUserLittleSchema } from '../user';
import { jFileLittle, jFileLittleSchema } from '../file';
import { widgetLegacyMixedBooleanSchema } from './legacy';

export type WidgetQuickSurveyContentArr = {
    title: string;
    id?: number;
    mimetype?: string;
    file?: jFileLittle;
};

export const WidgetQuickSurveyContentArrSchema = zObject<WidgetQuickSurveyContentArr>({
    title: z.string(),
    id: z.number().optional(),
    mimetype: z.string().optional(),
    file: jFileLittleSchema.optional(),
});

export const widgetQuickSurveyContentSchema = z.object({
    arr: WidgetQuickSurveyContentArrSchema.array().optional(),
    css: z.record(z.string(), z.string()).optional(),
    widgets: widgetBaseSchema.array().optional(),
    open: widgetLegacyMixedBooleanSchema.optional(),
    multi: widgetLegacyMixedBooleanSchema.optional(),
    closing: widgetLegacyMixedBooleanSchema.optional(),
    isClosed: widgetLegacyMixedBooleanSchema.optional(),
    showResult: widgetLegacyMixedBooleanSchema.optional(),
    isNotDisabled: widgetLegacyMixedBooleanSchema.optional(),
    seeResponseAfter: widgetLegacyMixedBooleanSchema.optional(),
    anonymize: widgetLegacyMixedBooleanSchema.optional(),
});

export type WidgetQuickSurveyContent = z.infer<typeof widgetQuickSurveyContentSchema>;

export type WidgetQuickSurveyType = {
    name: WidgetsName.QuickSurvey;
    uniqid: string;
    content: WidgetQuickSurveyContent;
};
export const widgetQuickSurveyTypeSchema = zObject<WidgetQuickSurveyType>({
    name: z.literal(WidgetsName.QuickSurvey),
    uniqid: z.string(),
    content: widgetQuickSurveyContentSchema,
}) satisfies ZodType<WidgetType<WidgetQuickSurveyContent>>;

const ResponseSchema = z.array(
    z.object({
        userList: jUserLittleSchema.array(),
        counter: z.number(),
    }),
);

export const WidgetQuickSurveyResponseSchema = z.object({
    totalRespondent: z.number(),
    totalResponse: z.number(),
    userLoggedResponses: z.string().array(),
    userResponses: ResponseSchema,
});

export type WidgetQuickSurveyResponses = z.infer<typeof ResponseSchema>;

export type WidgetQuickSurveyResponse = z.infer<typeof WidgetQuickSurveyResponseSchema>;

export const WidgetQuickSurveyResponseUserListSchema = z.object({
    data: jUserLittleSchema.array(),
    cnt: z.number(),
    page: z.number(),
    limit: z.number(),
});

export type WidgetQuickSurveyResponseUserList = z.infer<typeof WidgetQuickSurveyResponseUserListSchema>;
